<template>
  <div class="savepwdmodelbox">
    <div v-if="!isSuccess">
      <h3 class="mb-3">修改名称</h3>
      <hr class="mb-4">
      <div class="form-group">
        <label>名称</label>
        <input type="name" v-model="name" class="form-control form-control-lg">
      </div>
      <div class="form-group">
        <label>密码</label>
        <input type="password" v-model="pwd" class="form-control form-control-lg">
      </div>
      <div class="form-group mb-3">
        <label>重复密码</label>
        <input type="password" v-model="repwd" class="form-control form-control-lg">
      </div>
      <small class="text-danger">* 填写密码表示本次修改密码</small>
      <br>
      <br>
      <button type="submit" class="btn btn-primary btn-block btn-lg" @click="loginFun">
        <i v-if="isLoading" class='iconfont icon-jiazai xuanzhuan'></i>
        立即修改
      </button>
    </div>
    <div class="isSuccessBox" v-else>
      <i class="iconfont icon-chenggong text-success"></i>
      <span>修改成功</span>
    </div>
  </div>
</template>

<script>
import generalMix from '@/util/mix/general';
import resultCommons from '@/util/resultcommons';
import { EventBus } from '@/util/eventBus';
import commons from '@/util/commons';
import * as types from '@/store/types';

export default {
  name: 'savepwdmodelbox',
  props:['parameter'],
  mixins: [generalMix],
  data () {
    return {
      name: '',
      pwd: '',
      repwd: '',
      isSuccess: false,
      isLoading: false
    }
  },
  methods:{
    // 登录
    loginFun() {
      EventBus.$emit('globalLoadingFun', {bool:true,loading:false});
      this.isLoading = true;
      // 可以执行登录
      resultCommons.apiSaveinfoname(this, { token: this.localUser.token, name:this.name, pwd: this.pwd , repwd: this.repwd }).then(app=>{
        if(app.state === 200){
          // 更新本地缓存
          const localOb = this.localUser;
          localOb.name = this.name;
          commons.saveTodos('localUser', localOb);
          // 更新本地路由的登录信息
          this.$store.commit(types.SAVE_LOCALUSER, { bool: true });
          // 执行其他操作
          this.$message.showMsgBox({ type: 'success', content: app.message });
          EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
          this.isLoading = false;
          // 切换为修改成功页面
          this.isSuccess = true;
        }else{
          EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
          this.isLoading = false;
          this.$message.showMsgBox({ type: 'warning', content: app.message });
        }
      });
    }
  },
  created() {
    this.name = this.localUser.name;
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style scoped lang='less'>

.savepwdmodelbox {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  background: #FFFFFF;
  color: #000000;
  width: 480px;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 1rem;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  overflow-y: auto;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  padding: 30px;
  div.isSuccessBox{
    min-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    i{
      font-size: 56px;
    }
    span{
      margin-top: 50px;
      font-size: 16px;
    }
  }
}
@media (max-width: 767px) {
  .savepwdmodelbox {
    width: 80vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/user/Savename.vue